import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Filtres", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Statistiques", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "content statistics" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Chargement...", -1)

import { useMetaTitle } from "@/domains/app/pageMeta";
import { ref } from "@vue/reactivity";
import FilterSheets from "./FilterSheets.vue";
import ShowStatistics from "./ShowStatistics.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isFiltering = ref(true);

useMetaTitle().setTitle("Statistiques");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["tab", { active: isFiltering.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isFiltering.value = true))
      }, _hoisted_4, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tab", { active: !isFiltering.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (isFiltering.value = false))
      }, _hoisted_6, 2)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(FilterSheets)
          ]),
          fallback: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }))
      ], 512), [
        [_vShow, isFiltering.value]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(ShowStatistics)
      ], 512), [
        [_vShow, !isFiltering.value]
      ])
    ])
  ]))
}
}

})